module.exports = __webpack_public_path__ + "img/serve_05@2x.16cd0565.png";